exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".flatpickr-calendar{max-height:640px}.flatpickr-calendar.static.arrowBottom{top:auto;bottom:calc(100% + 10px)}.flatpickr-calendar .close-wrapper{height:40px;border-top:1px solid #e6e6e6;cursor:pointer}.flatpickr-calendar .close-wrapper:hover{background-color:rgba(0,0,0,.05)}.flatpickr-calendar .close-wrapper a{display:inline-block;line-height:40px;width:100%;color:#333}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-866fe894!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/App/protected/components/banet-datetime-picker/plugins/VueBulmaDatepicker/WrapperInput.vue
// module id = 602
// module chunks = 0